import LocationPin from '../src/LocationPin';
export default LocationPin;
